import React, { useEffect, useState } from 'react';
import { MdAddCircleOutline } from 'react-icons/md';
import { Link } from 'react-router-dom';
import Table from './Table';
import api from '~/services/api';
import { Container, TableContainer } from './styles';
import { BarLoader } from '~/components';

function ClientList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function loadClients() {
      const response = await api.get('/client');
      setData(response.data);
      setLoading(false);
    }
    loadClients();
  }, []);
  return (
    <Container>
      {loading ? (
        <BarLoader />
      ) : (
        <>
          <header>
            <Link to="/client/create">
              <MdAddCircleOutline color="#FFF" size={22} />
              New Client
            </Link>
          </header>
          <TableContainer>
            <Table data={data} />
          </TableContainer>
        </>
      )}
    </Container>
  );
}

export default ClientList;
